import axios from 'axios';
import API from '../config/API';

// walletService — the signed-in customer's "wallet": the gift cards they hold
// across salons. Wired to the Voucher V2 customer endpoints (user-scoped).
// Auth headers mirror giftCard.service (Basic + accessToken).
export const walletService = {
  getMyGiftCards,
  getMyLoyaltyCards,
  setGiftCardDesign,
  claimGiftCard,
};

const headers = () => {
  const accessToken = localStorage.getItem('accessToken') || '';
  return {
    'Content-Type': 'application/json',
    authorization: 'Basic YmV1YXBwOmJldWFwcA==',
    accessToken: `${accessToken}`,
  };
};

// BE success envelope: { statusCode, responseData: { status, message, data } }.
const unwrap = (res) => (res && res.data && res.data.responseData && res.data.responseData.data) || {};

// The user's loyalty cards across all salons (kind:'loyalty' wallet items).
// Lives on the v2 result envelope (not the voucher data envelope). Resolves
// to [] on any error so the wallet shows its honest empty state rather than
// breaking if the endpoint is unavailable.
async function getMyLoyaltyCards() {
  try {
    if (!API.LOYALTY_WALLET) return [];
    const res = await axios.get(API.LOYALTY_WALLET, { headers: headers() });
    const result = res && res.data && res.data.responseData
      && (res.data.responseData.result || res.data.responseData.data || res.data.responseData);
    return (result && result.cards) || [];
  } catch (e) {
    return [];
  }
}

// The user's gift cards across all salons (wallet card shape).
async function getMyGiftCards() {
  const res = await axios.post(API.VOUCHER_MY_LIST, {}, { headers: headers() });
  return unwrap(res).giftCards || [];
}

// Set (or change) the cosmetic design on a card the user owns.
async function setGiftCardDesign(cardId, designId) {
  const res = await axios.post(API.VOUCHER_SET_DESIGN, { cardId, designId }, { headers: headers() });
  return unwrap(res);
}

// Claim a gift card by code → bind to the signed-in user. Resolves the claimed
// card; rejects (axios error) on not-found / already-claimed-by-another.
async function claimGiftCard(code) {
  const normalized = (code || '').trim().toUpperCase();
  const res = await axios.post(API.VOUCHER_CLAIM, { code: normalized }, { headers: headers() });
  return unwrap(res);
}
